import Vue from 'vue'
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    name: 'resetPwd',
    path: '/resetPwd/:account',
    component: ()=> import('../components/ResetPassword')
  },
  {
    name: 'login',
    path: '/*',
    component: ()=> import('../components/TheLogin') 
  },
]

export default new VueRouter({
  routes,
  mode: 'history',
})